// RADAR OPERATIVO — lógica PURA de densidad. Sin React, sin red: testeable aislada.
// Regla crítica del contrato: una atención activa NUNCA queda oculta por la densidad elegida.
// El sistema puede AUTO-EXPANDIR; jamás auto-encoge.
export const DENSIDADES = [4, 8, 16, 32, "todos"];
export const DENSIDAD_KEY = "galarya_radar_densidad";

export function densidadValida(v) {
  if (v === "todos") return true;
  const n = Number(v);
  return DENSIDADES.includes(n) ? n : null;
}

// Devuelve la densidad EFECTIVA: la elegida, o la mínima que alcanza para no esconder
// ninguna atención activa (4 -> 8 -> 16 -> 32 -> todos).
export function densidadEfectiva(elegida, atencionesActivas = 0) {
  if (elegida === "todos") return "todos";
  const n = Number(elegida);
  if (!Number.isFinite(n)) return "todos";
  if (atencionesActivas <= n) return n;
  const escalon = [4, 8, 16, 32].find((d) => atencionesActivas <= d);
  return escalon || "todos";
}

export const autoExpandida = (elegida, efectiva) => elegida !== "todos" && efectiva !== Number(elegida);

// Cuántas tarjetas se pintan.
export function visibles(tarjetas, efectiva) {
  return efectiva === "todos" ? tarjetas : tarjetas.slice(0, efectiva);
}

// Variante de tarjeta por densidad. En "Todos" el detalle se degrada con la población real:
// una cartera pequeña no tiene por qué verse comprimida.
export function variante(efectiva, total = 0) {
  if (efectiva === 4) return "xl";
  if (efectiva === 8) return "l";
  if (efectiva === 16) return "m";
  if (efectiva === 32) return "s";
  if (total <= 8) return "l";
  if (total <= 16) return "m";
  if (total <= 32) return "s";
  return "xs";
}

export const COLUMNAS = {
  xl: "grid-cols-1 sm:grid-cols-2",
  l: "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4",
  m: "grid-cols-2 sm:grid-cols-3 lg:grid-cols-4",
  s: "grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 2xl:grid-cols-8",
  xs: "grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-10",
};

// Cuántos hechos recientes muestra cada variante (contrato §12).
export const HECHOS_VISIBLES = { xl: 3, l: 2, m: 1, s: 1, xs: 1 };
